import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';

import { CertificateAssignRequestComponent } from './certificate-assign-request.component';
import { AcceptCertificationComponent } from './accept/accept.component';
import { CertificateIconModule } from 'components/certificate/certificate-icon/certificate-icon.module';
import { DatePickerModule, FileUploadModule } from '@certemy/ui-components';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { ConfirmInfoModule } from 'components/upload-confirm/confirm-info.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    CertificateIconModule,
    DatePickerModule,
    FileUploadModule,
    InlineErrorModule,
    ConfirmInfoModule,
  ],
  exports: [CertificateAssignRequestComponent],
  declarations: [CertificateAssignRequestComponent, AcceptCertificationComponent],
})
export class CertificateAssignRequestModule {}
